import InfoTransferMessage from './InfoTransferMessage'
export default InfoTransferMessage
